export const PARTICIPANT_ADD = "PARTICIPANT_ADD"
export const PARTICIPANT_REMOVE = "PARTICIPANT_REMOVE"
export const PARTICIPANT_UPDATE = "PARTICIPANT_UPDATE"
export const PARTICIPANT_HAVE_ROLE_LIST = "PARTICIPANT_HAVE_ROLE_LIST"
export const PARTICIPANT_NO_ROLE_LIST = "PARTICIPANT_NO_ROLE_LIST"
export const PARTICIPANT_ERROR = "PARTICIPANT_ERROR"
export const PARTICIPANT_PENDING = "PARTICIPANT_PENDING"
export const PARTICIPANT_PENDING_DONE = "PARTICIPANT_PENDING_DONE"
